import { Injectable } from "@angular/core";
import { ResolveProtectedShortLinkGQL, ResolveShortLinkGQL } from "@ankaadia/graphql";
import { map, Observable } from "rxjs";
import { registerNoLoginOperation } from "../../shared/interceptors/auth.interceptor";

@Injectable({ providedIn: "root" })
export class ShortLinkService {
  constructor(
    private readonly resolve: ResolveShortLinkGQL,
    private readonly resolveProtected: ResolveProtectedShortLinkGQL
  ) {
    registerNoLoginOperation(this.resolve);
  }

  resolveShortLink(shortLink: string): Observable<string> {
    return this.resolve.fetch({ shortLink: shortLink }).pipe(map((result) => result.data.resolveShortLink));
  }

  resolveProtectedShortLink(shortLink: string): Observable<string> {
    return this.resolveProtected
      .fetch({ shortLink: shortLink })
      .pipe(map((result) => result.data.resolveProtectedShortLink));
  }
}
